import { createPortal } from 'react-dom';
import type { MutableRefObject } from 'react';
import EndTimeForeverPicker from './EndTimeForeverPicker';
import WeekGroup from './WeeKGroup';
import type { TimeRangeItem } from './TimeGroup';
import dayjs from 'lib/dayjs';
import type { DayOfWeeks } from './WeeKGroup';
import useSmartField from 'hooks/useSmartField';

type WeekTypeValue = {
  dtRange:
    | {
        startAt: string | undefined;
        endAt: string | undefined;
      }
    | undefined;
  weekRepeat:
    | {
        dayOfWeeks: DayOfWeeks;
        timeRanges: Pick<TimeRangeItem, 'startAt' | 'endAt'>[];
      }[]
    | undefined;
};

type TypeWeekPickerImplProps = {
  hookRef: MutableRefObject<null>;
  fieldNamePrefix: string;
  value?: WeekTypeValue;
  onChange?: (value: WeekTypeValue) => void;
};

function TypeWeekPickerImpl(props: TypeWeekPickerImplProps) {
  const { hookRef, fieldNamePrefix } = props;

  const { field: sdtField, helpers: stdHelper } = useSmartField(
    `${fieldNamePrefix}.activeDuration`,
  );

  if (!hookRef.current) return null;
  return (
    <>
      <EndTimeForeverPicker
        noForever
        value={
          sdtField?.value?.startAt
            ? [
                dayjs(sdtField?.value?.startAt, 'YYYY-MM-DD HH:mm'),
                dayjs(sdtField?.value?.endAt, 'YYYY-MM-DD HH:mm'),
              ]
            : undefined
        }
        onChange={(value) => {
          const startAt = value?.[0];
          const endAt = value?.[1];
          stdHelper.setValue({
            startAt,
            endAt,
          });
        }}
      />
      {createPortal(
        <WeekGroup fieldNamePrefix={`${fieldNamePrefix}.weekRepeat`} />,
        hookRef.current!,
      )}
    </>
  );
}

export default TypeWeekPickerImpl;
